
import React from 'react';
import { CloseIcon } from '@/components/icons';

interface ArticleTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: 'Press Release' | 'Strategic Pillars' | 'Programmes') => void;
}

const Modal: React.FC<{ isOpen: boolean; onClose: () => void; children: React.ReactNode }> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center p-4" onClick={onClose} role="dialog" aria-modal="true">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl" onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

const ArticleTypeModal: React.FC<ArticleTypeModalProps> = ({ isOpen, onClose, onSelect }) => {
  const articleTypes = [
    { name: 'Press Release', iconPath: '/newsroom-icon.png' },
    { name: 'Strategic Pillars', iconPath: '/strategicpillars-icon.png' },
    { name: 'Programmes', iconPath: '/file-icon.png' },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold text-gray-800">Articles Type</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800" aria-label="Close modal">
            <CloseIcon className="w-6 h-6" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-6">Select an article type to create</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {articleTypes.map((type) => (
            <button
              key={type.name}
              onClick={() => onSelect(type.name as 'Press Release' | 'Strategic Pillars' | 'Programmes')}
              className="group flex flex-col p-6 bg-gray-50 rounded-lg border border-gray-200 hover:bg-forestGreen-100 hover:border-forestGreen-100 transition-all duration-200"
            >
              <div className="flex flex-col space-y-3 sm:space-y-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-imageBg-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                  <img 
                    src={type.iconPath}
                    alt={type.name}
                    className="w-5 h-5 md:w-7 md:h-7 object-contain"
                  />
                </div>
                <span className="text-sm font-semibold text-gray-700 group-hover:text-white text-left transition-colors">
                  {type.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ArticleTypeModal;
